export default class SiteSearch {
  constructor() {
    this.searchContainer = document.querySelector("#site-search")

    this.searchLinks = document.querySelectorAll(".toggle-site-search-link")

    for (let searchLink of this.searchLinks) {
      searchLink.addEventListener("click", this.toggle.bind(this))
    }
  }

  toggle(e) {
    e.preventDefault()

    this.searchContainer.classList.toggle("block")
  }
}
